import MiInfiniteScroll from './MiInfiniteScroll.vue'

export default MiInfiniteScroll
